import $ from 'jquery';
import { ErrorPopover, Tabs } from "rustig";
import { FormValidation, IValidationHandler } from "rustig";
import TagSearch from '../tagsearch';

export class TagSearchValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    let error = $error[0];
    if (!error.matches('[data-tag-search-root-id]'))
      return false;

    let rootId = error.getAttribute('data-tag-search-root-id');
    let root = document.querySelector('tag-search-root'.asDataSelector(rootId));
    let tagSearch = root.querySelector(TagSearch.wireup) as HTMLElement;
    if ($(tagSearch).data('error-handled') == true)
      return true;

    TagSearch.load(tagSearch); // wireup will not have been hit yet
    let errorMessage = error.innerHTML;
    $(tagSearch).data('error-handled', true);

    var input = root.querySelector('.selectize-input');
    input.classList.add(FormValidation.validationClass);
    $error.remove();
    new ErrorPopover({ sizing: 'default' }).append(<JQuery> $(input), tagSearch.id, errorMessage, 'focusin');

    return true;
  }
}